import React from "react";
import { Check, X, Info } from "lucide-react";
import styles from "./styles.module.scss";
import Tooltip from "../Tooltip";
import { cn } from "@utils/utils";

interface FeatureItemProps {
  title: string;
  subtitle?: string;
  included?: boolean;
  tooltip?: string;
  className?: string;
}

export const FeatureItem: React.FC<FeatureItemProps> = ({
  title,
  subtitle,
  included = true,
  tooltip,
  className,
}) => {
  const Icon = included ? Check : X;

  return (
    <div className={cn(styles.feature, className)}>
      <Icon
        size={16}
        className={cn(
          styles.feature__icon,
          included
            ? styles.feature__icon_included
            : styles.feature__icon_missing
        )}
      />
      <div className={styles.feature__content}>
        <div className={styles.feature__title}>
          {title}
          {tooltip && (
            <Tooltip content={tooltip}>
              <Info size={14} className={styles.feature__info} />
            </Tooltip>
          )}
        </div>
        {subtitle && <p className={styles.feature__subtitle}>{subtitle}</p>}
      </div>
    </div>
  );
};
